<template>
  <v-stepper
      v-if="items.length > 1"
      v-bind="schema.properties['x-props']"
      :value="index+1"
  >
    <v-stepper-header
        v-bind="schema.properties['x-props']"
    >
      <template v-for="(item, key) in items">
        <!-- all siblings must have the same :key or v-bind:key-->
        <v-stepper-step
            :key="key+1+'key'"
            :step="key+1"
            :complete="key < index"
            v-bind="schema.properties['x-props']"
        >
          {{ item.name }}
        </v-stepper-step>
        <v-divider v-if="key !== items.length - 1" :key="key"></v-divider>
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: "TcnFormStepper",
  components: {},
  props: {
    value: { type: String, default: '' },
    options: { type: Object, required: true },
    schema: { type: Object, required: true },
    fullSchema: { type: Object, required: true },
    fullKey: { type: String, required: true },
    label: { type: String, default: '' },
    htmlDescription: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rules: { type: Array, required: true },
    on: { type: Object, required: true }
  },
  data() {
    return {
      items: [],
      index: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
    this.items = this.schema.properties.items
    this.index = this.items.findIndex(item => item.status === this.value)
  }
}
</script>

<style scoped lang="css">

</style>
